var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',[_c('tables',{attrs:{"search-place":"top","columns":_vm.columns},model:{value:(_vm.tableData),callback:function ($$v) {_vm.tableData=$$v},expression:"tableData"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }